import React from 'react';
import { LanguageProvider } from './components/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { WhyChooseUs } from './components/WhyChooseUs';
import { SpecialOffer } from './components/SpecialOffer';
import { Reviews } from './components/Reviews';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-brand-marble font-inter selection:bg-brand-gold selection:text-brand-navy" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <TrustBar data-id="element-5" />
          <Services data-id="element-6" />
          <BeforeAfter data-id="element-7" />
          <WhyChooseUs data-id="element-8" />
          <SpecialOffer data-id="element-9" />
          <Reviews data-id="element-10" />
          <ContactForm data-id="element-11" />
        </main>
        <Footer data-id="element-12" />
        <WhatsAppButton data-id="element-13" />
      </div>
    </LanguageProvider>;
}